import { React, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { useParams, useNavigate } from 'react-router-dom';

import { Modal, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import OfferCard from '../../../Constants/OfferCard';
import SyndicRectangleButton from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain'
import SyndicRectangleButtonSnd from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonSecond';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';

const NewOfferRecap = () => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [opened, { open, close }] = useDisclosure(false);

    let {id} = useParams()

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    const HandleOfferPublication  = async () => {
        if (opened) return;
        open();
        try {
            const token = localStorage.getItem('token');
            await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/add-offer/${id}`, {
                method: "POST",
                body: JSON.stringify({
                    id: id,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            setTimeout(() => {
                navigate('/app/profile/menu');
            }, 1000)

        } catch (error) {
        }
    }

    const HandleModification = () => {
        navigate(`/app/offers/preoffer-edit/${id}`)

    }
        return(
            <>
                {isMobile ? (
                    <>
                        <div>
                            <OfferCard isEditOffer={true} />
                            <div className="width90pCenter mrgT30">
                                <SyndicRectangleButtonSnd onClick={HandleModification}>
                                    Retour
                                </SyndicRectangleButtonSnd>

                                <div className="mrgB10"></div>

                                <SyndicRectangleButton
                                    onClick={HandleOfferPublication}
                                    >
                                    Publier mon offre
                                </SyndicRectangleButton>
                                {open ?
                                    <Modal 
                                        centered
                                        size="auto"
                                        opened={opened}
                                        onClose={close}
                                        withCloseButton={false}>
                                        <p className="txtCenter noMrgTB  txt15">
                                            Votre offre a été publiée
                                        </p>
                                    </Modal> 
                                : 
                                    ""
                                }                    
                                <div className="mrgB20"></div>    
                            </div>

                        </div>
                    </>
                 ) : (
                    <>
                        <div>
                            <AppDesktopLogo/>
                            <OfferCard
                                isEditOffer={true}
                                desktopFooterActions={
                                    <div className='horizontal' style={{ gap: 12 }}>
                                        <Button
                                            variant="outline"
                                            color="dark"
                                            radius="xl"
                                            size="lg"
                                            styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                            onClick={HandleModification}
                                            >
                                            Modifier
                                        </Button>
                                        <Button
                                            color="dark"
                                            radius="xl"
                                            size="lg"
                                            styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                            onClick={HandleOfferPublication}
                                            >
                                            Publier mon offre
                                        </Button>
                                    </div>
                                }
                            />
                            {open ?
                                <Modal
                                    centered
                                    size="auto"
                                    opened={opened}
                                    onClose={close}
                                    withCloseButton={false}>
                                    <p className="txtCenter noMrgTB  txt16">
                                        Votre offre a été publiée
                                    </p>
                                </Modal>
                            :
                                ""
                            }
                        </div>
                    </>
                 )}
            </>
        )
    
}

export default NewOfferRecap;